import "./EmailForm.scss";

const EmailForm = ({emailInfo, onChange, errMessage})=> {

    return (
        <section className="email">
            <div className="email__wrapper">
                <p className="email__description">Within a few hours, a VL Energy representative will be in contact with you to deliver a ES-PEMS price indication beginning your journey to accurate and reliable emissions data.</p>
                {errMessage && <p className="email__error">{errMessage}</p>}
                <input required type="text" className="email__ipt" name="firstName" placeholder="First name*" value={emailInfo.firstName} onChange={onChange}></input>
                <input required type="text" className="email__ipt" name="lastName" placeholder="Last Name*" value={emailInfo.lastName} onChange={onChange}></input>
                <input required type="email" className="email__ipt" name="email_from" placeholder="Business email only*" value={emailInfo.email_from} onChange={onChange}></input>
                <input required type="text" className="email__ipt" name="jobTitle" placeholder="Job title*" value={emailInfo.jobTitle} onChange={onChange}></input>
                <input required type="text" className="email__ipt" name="organization" placeholder="Organization name*" value={emailInfo.organization} onChange={onChange}></input>
            </div>
        </section>
    );
}

export default EmailForm;